import { Model, belongsTo, hasMany } from 'miragejs'

export default Model.extend({
  contactDetail: belongsTo(),
  schoolSubscriptions: hasMany(),
  teachers: hasMany(),
  students: hasMany(),
  schoolClasses: hasMany(),
  subscriptionCoordinators: hasMany(),
  schoolSubscriptionUtilisations: hasMany(),
  schoolRollovers: hasMany(),
})
